module.exports = __webpack_public_path__ + "img/1f60a.f1d8e3e.svg";